import React, { useState } from "react";
const years = [2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033];
const states = ['Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','Florida','Georgia','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Maryland','Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota','Ohio','Oklahoma','Oregon','Pennsylvania','Rhode Island','South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virginia','Washington','West Virginia','Wisconsin','Wyoming'];

const SinglePayment = (props) => {
  const { step1Fields, setStep1Fields, emailError, handleSubmit, months, handleErrorChange, onlyInternet } = props;

  const handleChange = (value, field) => {
    handleErrorChange(field, !value);
    setStep1Fields((prev) => {
      const toReturn = { ...prev };
      toReturn[field] = value;
      return toReturn;
    })
  }

  const handleMoney = (value) => {
    const parsed = parseFloat(value);
    const formatted = parsed.toFixed(2);

    return formatted;
  };

  return (
    <div style={{
      textAlign: "left",
      padding: "2rem",
      width: "75vw",
      margin: "0 30%",
      backgroundColor: "transparent",
      backgroundImage: "linear-gradient(180deg, #000000D1 0%, #464646D9 100%)"
    }}>
      {

      }
      <div style={{ marginBottom: "2rem" }}>
        <h3 style={{ fontSize: "1.5em", textDecoration: "underline" }}>Single Payment {onlyInternet ? "for Internet Only" : ""}</h3>
        <div style={{ display: "flex", gap: "1rem" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <label for="nameOnCard">Name On Card <span style={{ color: "red" }}>*</span></label>
            <input
              id="nameOnCard"
              onChange={(e) => handleChange(e.target.value, "nameOnCard")}
              value={step1Fields.nameOnCard}
              style={{
                borderColor: "#F7780B",
                height: "28px",
                borderWidth: "0.5px",
              }}
              />
          </div>
        </div>
        <br />
        <div style={{ display: "flex", gap: "1rem" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <label for="creditCardNumber">Credit Card Number <span style={{ color: "red" }}>*</span></label>
            <input id="creditCardNumber" onChange={(e) => handleChange(e.target.value, "creditCardNumber")} value={step1Fields.creditCardNumber} style={{
                borderColor: "#F7780B",
                height: "28px",
                borderWidth: "0.5px"
              }}/>
          </div>
        </div>
        <br />
        <div style={{ display: "flex", gap: "1rem" }}>
          <div style={{ display: "flex", flexDirection: "column", width: "30`%", gap: "8px" }}>
            <label for="expirationMonth">Expiration Month <span style={{ color: "red" }}>*</span></label>
            <select
              id="expirationMonth"
              onChange={(e) => handleChange(e.target.value, "expirationMonth")} value={step1Fields.expirationMonth}
              style={{
                height: "28px",
                borderColor: "#F7780B",
                borderWidth: "0.5px"
              }}
              >
              {months.map((month) => (<option value={month}>{month}</option>))}
            </select>
          </div>
          <div style={{ display: "flex", flexDirection: "column", width: "25%", gap: "8px" }}>
            <label for="expirationYear">Expiration Year <span style={{ color: "red" }}>*</span></label>
            <select
              id="expirationYear"
              onChange={(e) => handleChange(e.target.value, "expirationYear")} value={step1Fields.expirationYear}
              style={{
                height: "28px",
                borderColor: "#F7780B",
                borderWidth: "0.5px"
              }}
              >
              {years.map((year) => (<option value={year}>{year}</option>))}
            </select>
          </div>
          <div style={{ display: "flex", flexDirection: "column", width: "15%", gap: "8px" }}>
            <label for="cvv">CVV <span style={{ color: "red" }}>*</span></label>
            <input id="cvv" onChange={(e) => handleChange(e.target.value, "cvv")} value={step1Fields.cvv} style={{
                borderColor: "#F7780B",
                height: "28px",
                borderWidth: "0.5px"
              }}/>
          </div>
        </div>
        <br />
        <div style={{ display: "flex", gap: "1rem" }}>
              <div style={{ display: "flex", flexDirection: "column", width: "50%", gap: "8px" }}>
                <label for="phoneNumber">Phone Number <span style={{ color: "red" }}>*</span></label>
                <input id="phoneNumber" onChange={(e) => handleChange(e.target.value, "phoneNumber")} value={step1Fields.phoneNumber} style={{
                  borderColor: "#F7780B",
                      height: "28px",
                      borderWidth: "0.5px"
                }} />
              </div>
        </div>
      </div>
      <div style={{ marginBottom: "2rem" }}>
        <h3>Tenant Information</h3>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "75%", marginBottom: "1rem" }}>
            <label for="unitNumber">Unit Number:</label>
            <input id="unitNumber" onChange={(e) => handleChange(e.target.value, "unitNumber")} value={step1Fields.unitNumber} style={{
                borderColor: "#F7780B",
                height: "28px",
                borderWidth: "0.5px"
              }}/>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "75%", marginBottom: "1rem" }}>
            <label for="street">Street: <span style={{ color: "red" }}>*</span></label>
            <input id="street" onChange={(e) => handleChange(e.target.value, "street")} value={step1Fields.street} style={{
                borderColor: "#F7780B",
                height: "28px",
                borderWidth: "0.5px"
              }}/>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "75%", marginBottom: "1rem" }}>
            <label for="city">City: <span style={{ color: "red" }}>*</span></label>
            <input id="city" onChange={(e) => handleChange(e.target.value, "city")} value={step1Fields.city} style={{
                borderColor: "#F7780B",
                height: "28px",
                borderWidth: "0.5px"
              }}/>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "75%", marginBottom: "1rem" }}>
            <label for="state">State: <span style={{ color: "red" }}>*</span></label>
            <select
              id="state"
              onChange={(e) => handleChange(e.target.value, "state")} value={step1Fields.state}
              style={{
                height: "28px",
                borderColor: "#F7780B",
                borderWidth: "0.5px"
              }}
              >
              {states.map((state) => (<option value={state}>{state}</option>))}
            </select>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "75%", marginBottom: "1rem" }}>
            <label for="zip">Zip: <span style={{ color: "red" }}>*</span></label>
            <input id="zip" onChange={(e) => handleChange(e.target.value, "zip")} value={step1Fields.zip} style={{
                borderColor: "#F7780B",
                height: "28px",
                borderWidth: "0.5px"
              }}/>
          </div>
      </div>
      <div style={{ marginBottom: "2rem" }}>
        <h3>Email for Confirmation</h3>
        <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "75%", marginBottom: "1rem" }}>
            <label for="email">Email Address</label>
            <input id="email" onChange={(e) => handleChange(e.target.value, "email")} value={step1Fields.email} style={{
                borderColor: "#F7780B",
                height: "28px",
                borderWidth: "0.5px"
              }}/>
        </div>
        {emailError ? <h3 style={{ color: "red" }}>EMAILS DO NOT MATCH</h3> : null}
        <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "75%", marginBottom: "1rem" }}>
            <label for="confirmEmail">Confirm Email Address</label>
            <input id="confirmEmail" onChange={(e) => handleChange(e.target.value, "confirmEmail")} value={step1Fields.confirmEmail} style={{
                borderColor: "#F7780B",
                height: "28px",
                borderWidth: "0.5px"
              }}/>
        </div>
      </div>
      <div>
        <h3>Payment Detail</h3>
        <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "45%", marginBottom: "1rem" }}>
          <label for="amount" style={{ fontWeight: "800" }}>Internet and TV Service:</label>
          <p style={{ fontSize: "12px", margin: 0 }}>(Hardware included)</p>
          <p for="amount" style={{ fontWeight: 600 }}>${step1Fields.amount}</p>
          {/* <input id="amount" onChange={(e) => handleChange(e.target.value, "amount")} style={{
                borderColor: "#F7780B",
                height: "28px",
                borderWidth: "0.5px"
              }}/> */}
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "75%", marginBottom: "1rem" }}>
          <label style={{ fontWeight: "800" }}>Technology Fee (3.99%): </label>
          <p for="techFee" style={{ fontWeight: 600 }}>${step1Fields.techFee}</p>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "75%", marginBottom: "1rem" }}>
          <label style={{ fontWeight: "800" }}>Tax (7.44%): </label>
          <p for="tax" style={{ fontWeight: 600 }}>${step1Fields.tax}</p>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "75%", marginBottom: "1rem" }}>
          <label style={{ fontWeight: "800" }}>Total Amount: </label>
          <p style={{ fontWeight: 700 }}>${step1Fields.totalAmount}</p>
        </div>
      </div>
      <div
        style={{
          marginBottom: "1rem",
        }}
      >
        <input type="checkbox" id="termsAccepted" value={step1Fields.termsAccepted} onChange={(e) => handleChange(e.target.checked, "termsAccepted")} />
        <label for="termsAccepted" style={{ textTransform: "none", margin: "1rem", fontWeight: 600, fontSize: "18px" }}>I accept the{" "}
          <a
            href="https://www.mi3connect.com/terms/"
            target="_blank"
            style={{
              textDecoration: "none",
              color: "#F7780B",
              textTransform: "none",
              fontWeight: 600
            }} rel="noreferrer"
          >
            Terms of Service
          </a>
        </label>
      </div>
      <button
        onClick={handleSubmit}
        style={{
          width: "50%",
          height: "36px",
          background: "#83EEFF",
          border: "none",
          borderRadius: "3px"
        }}
      >Press here to pay!</button>
    </div>
  )

}

export default SinglePayment;